import type { ReactNode } from "react";

import {
    TradeManageMigrationPanel,
    type TradeManageRecord
} from "@/views/pages/tradeManage/TradeManageMigrationPrimitives";

export interface indexProps {
    data?: TradeManageRecord;
    items?: TradeManageRecord[];
    open?: boolean;
    visible?: boolean;
    children?: ReactNode;
    onClose?: () => void;
    onCancel?: () => void;
    onSubmit?: (data: TradeManageRecord) => void;
    onRefresh?: () => void;
    onSelect?: (item: TradeManageRecord) => void;
    onAction?: (item: TradeManageRecord) => void;
}

/** components / caclenderTab / index：保留数据展示、编辑提交和父级事件回调。 */
export default function MigrationComponent(props: indexProps) {
    const handleSubmit = (data: TradeManageRecord) => {
        props.onSubmit?.(data);
        props.onRefresh?.();
    };
    return (
        <TradeManageMigrationPanel
            title="components / caclenderTab / index"
            data={props.data}
            items={props.items}
            fields={["id", "name", "state", "createTime"]}
            dialog={false}
            open={props.open ?? props.visible ?? false}
            onClose={props.onClose ?? props.onCancel}
            onSubmit={handleSubmit}
            onSelect={props.onSelect}
            onAction={props.onAction}
        >
            {props.children}
        </TradeManageMigrationPanel>
    );
}
